import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./Spravy.scss";

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";
import * as spravyActions from "../../actions/spravyActions";

// prop types
import odberatelPropTypes from "../../propTypes/odberatelPropTypes";
import spravyPropTypes from "../../propTypes/spravyPropTypes";

// core web components
import Grid from "../../coraWebComponents/grid/GridWrapper";
import flags from "../../coraWebComponents/utils/flags";
import Tab from "../../coraWebComponents/Tab";
import Tabs from "../../coraWebComponents/TabsWrapper";

// components
import Detail from "./Detail";

class Spravy extends React.Component {
  constructor(props) {
    super(props);

    this.gridFilter = { filters: [] };
    this.gridSort = [];
    this.gridPage = { skip: 0, take: 10 };
  }

  cellRender = (tdElement, cellProps) => {
    const { dataItem } = cellProps;

    var tdProps = { ...tdElement.props };

    tdProps.className += (dataItem.L_PRECITANE ? "" : "neprecitane");

    return React.cloneElement(tdElement, { ...tdProps }, tdElement.props.children);
  }
  // GRID PROPS
  genGridSchema() {
    return [
      {
        field: "ZP_SPRAVY_D_PUB",
        title: "Dátum publikácie",
        filter: "date",
        format: "{0:dd.MM.yyyy}",
        width: "150px",
      },
      {
        field: "ZP_SPRAVY_TEXT",
        title: "Text",
        width: "auto",
        filter: "text",
      },
      {
        field: "ADRESAT",
        title: "Adresát",
        width: "200px",
        filter: "text",
      },
    ];
  }
  onChangeHandle = (filter, sort, page) => {
    this.gridFilter = filter;
    this.gridSort = sort;
    this.gridPage = page;
  };
  onGet = async (I_ZP_SPRAVY_UZ, filter) => {
    const {
      listSprava,
      changeSprava,
      updateSprava,
      getCountNeprecitaneSpravy,
      odberatel,
      isUserAdmin,
    } = this.props;

    const spravaUZ = listSprava.find(
      (s) => s.I_ZP_SPRAVY_UZ === I_ZP_SPRAVY_UZ
    );

    if (spravaUZ) {
      if (!spravaUZ.L_PRECITANE) {
        const updateMsg = !isUserAdmin || spravaUZ.I_ORGAN === null;

        if (updateMsg) {
          spravaUZ.L_PRECITANE = true;
          await updateSprava({
            ...spravaUZ,
            ZP_SPRAVY_D_PUB: spravaUZ.ZP_SPRAVY_D_PUB,
          });

          await getCountNeprecitaneSpravy(odberatel?.I_ORGAN || -1);
        }
      }
      changeSprava(spravaUZ);
    }
  };
  getListSpravaHandle = async () => {
    const {
      customFilters,
      getListSpravaCurrentUser,
      getCountNeprecitaneSpravy,
      odberatel,
    } = this.props;
    const { gridFilter, gridSort, gridPage } = this;

    await getListSpravaCurrentUser(
      gridFilter,
      gridSort,
      gridPage,
      customFilters
    );
    await getCountNeprecitaneSpravy(odberatel?.I_ORGAN || -1);
  };

  // SYSTEM METHODS
  componentDidMount = () => {
    const { showAppHeader, changeHeaderTitle } = this.props;

    showAppHeader(false);
    changeHeaderTitle("Správy");
  };
  render() {
    const { isLoading, total, listSprava, sprava } = this.props;

    return (
      <div className="row m-0 component">
        <div className="col p-0">
          <Tabs>
            <Tab title="Zoznam">
              <Grid
                data={listSprava}
                isLoading={isLoading}
                onChange={this.onChangeHandle}
                onDelete={() => { }}
                onGet={this.onGet}
                onGetList={this.getListSpravaHandle}
                primaryField={"I_ZP_SPRAVY_UZ"}
                schema={this.genGridSchema()}
                total={total}
                cellRender={this.cellRender}
                hidden={
                  flags.ADD | flags.COPY | flags.CANCEL | flags.FILTER | flags.COLUMN_MENU
                }
              />
            </Tab>
            <Tab title="Detail">
              <Detail
                onSubmit={() => { }}
                onGet={this.onGet}
                allData={listSprava}
                data={sprava}
                isLoading={isLoading}
              />
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  if (state.sprava.data === null) {
    state.sprava.data = {
      I_ZP_SPRAVY_UZ: 0,
      I_ZP_SPRAVY: -1,
      TEXT: "",
      D_PUB: null,
    };
  }

  return {
    // list sprava
    customFilters: state.listSprava.customFilters,
    isLoading: state.listSprava.isLoading,
    listSprava: state.listSprava.data,
    total: state.listSprava.total,
    update: state.listSprava.update,

    // odberetal
    isUserAdmin: state.user.data.Uzivatel.L_ADMIN,
    odberatel: state.odberatel.data,

    sprava: state.sprava.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getCountNeprecitaneSpravy: async (I_ORGAN) =>
    await dispatch(spravyActions.getCountNeprecitaneSpravy(I_ORGAN)),
  getListSpravaCurrentUser: async (
    gridFilter,
    gridSort,
    gridPage,
    customFilters
  ) =>
    await dispatch(
      spravyActions.getListSpravaCurrentUser({
        gridFilter,
        gridSort,
        gridPage,
        customFilters,
      })
    ),
  changeHeaderTitle: (title) => dispatch(appHeaderActions.changeHeaderTitle(title)),
  changeSprava: (data) => dispatch(spravyActions.changeSprava(data)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
  updateSprava: (data) => dispatch(spravyActions.updateSprava(data)),
});

Spravy.propTypes = {
  customFilters: PropTypes.arrayOf(PropTypes.object),
  changeHeaderTitle: PropTypes.func,
  changeSprava: PropTypes.func,
  isLoading: PropTypes.bool,
  isUserAdmin: PropTypes.bool,
  listSprava: PropTypes.arrayOf(spravyPropTypes.sprava),
  getCountNeprecitaneSpravy: PropTypes.func,
  getListSpravaCurrentUser: PropTypes.func,
  getSprava: PropTypes.func,
  odberatel: odberatelPropTypes.odberatel,
  showAppHeader: PropTypes.func,
  total: PropTypes.number,
  updateSprava: PropTypes.func,
  sprava: spravyPropTypes.sprava,
};

export default connect(mapStateToProps, mapDispatchToProps)(Spravy);
